import { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { TiTick, TiTimes } from "react-icons/ti";
import { hasPermission } from "../../../utils/hasPermission";
import { getVendorName } from "../../../utils/getVendorName";
import { useNavigate } from "react-router-dom";
import ExportCSV from "../../../components/ExportCsv/ExportCsv";
import toast from "react-hot-toast";
import CustomExport from "../../../components/CustomExport/CustomExport";
import {
    useApprovePendingRequestMutation,
    useFetchPendingQrsMutation,
    useRejectPendingRequestMutation,
} from "../../../features/tenant/pendingQrs/pendingQrsApi";

const qrTypes = {
    1: "ZFNG",
    2: "ZCRT",
};

const statusLabelOptions = [
    {
        value: "",
        label: "All",
    },
    {
        value: "1",
        label: "Pending",
    },
    {
        value: "2",
        label: "Approved",
    },
    {
        value: "3",
        label: "Rejected",
    },
];

const PendingQrs = () => {
    const navigate = useNavigate();

    const initialRequest = {
        mobile: "",
        limit: 10,
        offset: 0,
        status: "",
        startDate: "",
        endDate: "",
        app_user_id: "",
        product_code: "",
        product_name: "",
        unique_code: "",
        qr_type: "",
        qr_id: null,
    };

    const [
        fetchPendingList,
        { data: pendingListData, error: pendingListError },
    ] = useFetchPendingQrsMutation();
    const [
        approvePendingQr,
        { data: approvePendingQrData, error: approvePendingQrError },
    ] = useApprovePendingRequestMutation();
    const [
        rejectPendingQr,
        { data: rejectPendingQrData, error: rejectPendingQrError },
    ] = useRejectPendingRequestMutation();

    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const [csvData, setCsvData] = useState(null);
    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
    };

    const fetchPendingListFunction = () => {
        toast.loading("Please wait...");

        fetchPendingList({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: request,
        });
    };

    const fetchPendingListCsvFunction = async () => {
        const response = await fetchPendingList({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: { ...request, limit: 99999999, offset: 0 },
        }).unwrap();

        console.log(response, "PendingListCsvFunction===");

        if (response.status !== 200) {
            toast.error(response?.message);
            setCsvData([]);
        } else {
            setCsvData(response?.body?.list);
        }
    };

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    const handleApprove = async (e, row) => {
        const remark = window.prompt("Please add remarks");
        if (!remark) {
            toast.error("Please add a remark");
            return;
        }

        toast.loading("Please wait...");

        const response = await approvePendingQr({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: {
                id: row?.id,
                remark: remark,
            },
        }).unwrap();

        toast.dismiss();

        console.log(response, "===");

        if (response?.status == 200) {
            toast.success("Request approved!");
            fetchPendingListFunction();
        } else {
            toast.error("Something went wrong");
        }
    };

    const handleReject = async (e, row) => {
        const remark = window.prompt("Please add remarks");

        if (!remark) {
            toast.error("Please add a remark");
            return;
        }

        toast.loading("Please wait...");

        const response = await rejectPendingQr({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: {
                id: row?.id,
                remark: remark,
            },
        }).unwrap();

        toast.dismiss();

        console.log(response, "===");

        if (response?.status == 200) {
            toast.success("Request rejected!");
            fetchPendingListFunction();
        } else {
            toast.error("Something went wrong");
        }
    };

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Name",
            cell: (row) => row.user_name,
            sortable: true,
        },
        {
            name: "Mobile",
            cell: (row) => row.user_mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "Qr Id",
            cell: (row) => row.unique_code,
            sortable: true,
            width: "240px",
        },
        {
            name: "Batch Running Code",
            cell: (row) => row.batch_running_code,
            sortable: true,
            width: "240px",
        },
        // {
        //     name: "Batch Running Code",
        //     cell: (row) => row.batch_running_code,
        //     sortable: true,
        //     width: "200px",
        // },
        {
            name: "WSP",
            cell: (row) => row.points,
            sortable: true,
            //   width: "120px",
        },
        {
            name: "MRP",
            cell: (row) => row.mrp,
            sortable: true,
            //   width: "120px",
        },
        {
            name: "QR Type",
            cell: (row) => qrTypes[row.qr_type],
            sortable: true,
            //   width: "120px",
        },
        {
            name: "Product Code",
            cell: (row) => row.product_code,
            sortable: true,
            width: "200px",
        },
        {
            name: "Product Name",
            cell: (row) => row.product_name,
            sortable: true,
            width: "200px",
        },
        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString("en-IN", {
                timeZone: "UTC",
            }),
            sortable: true,
            width: "200px",
        },
        {
            name: "Remark",
            cell: (row) => row.remark,
            sortable: true,
            width: "200px",
        },
        {
            name: "Actions",
            cell: (row) => (
                <div>
                    {row.status == "1" && (
                        <div className="flex space-x-1 gap-2">
                            <button
                                onClick={(e) => handleApprove(e, row)}
                                className="flex justify-center items-center rounded bg-green-600 px-3 py-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#14a44d] transition duration-150 ease-in-out hover:bg-success-600 hover:shadow-[0_8px_9px_-4px_rgba(20,164,77,0.3),0_4px_18px_0_rgba(20,164,77,0.2)] focus:bg-success-600 focus:shadow-[0_8px_9px_-4px_rgba(20,164,77,0.3),0_4px_18px_0_rgba(20,164,77,0.2)] focus:outline-none focus:ring-0 active:bg-success-700 active:shadow-[0_8px_9px_-4px_rgba(20,164,77,0.3),0_4px_18px_0_rgba(20,164,77,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(20,164,77,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(20,164,77,0.2),0_4px_18px_0_rgba(20,164,77,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(20,164,77,0.2),0_4px_18px_0_rgba(20,164,77,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(20,164,77,0.2),0_4px_18px_0_rgba(20,164,77,0.1)]"
                            >
                                <TiTick className="mr-1" />
                                Approve
                            </button>
                            <button
                                onClick={(e) => handleReject(e, row)}
                                className="flex justify-center items-center rounded bg-danger px-3 py-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]"
                            >
                                <TiTimes className="mr-1" />
                                Reject
                            </button>
                        </div>
                    )}

                    {row.status == "3" && (
                        <div className="bg-red-600 text-white px-2 py-1 rounded-full font-bold">
                            Rejected
                        </div>
                    )}

                    {row.status == "2" && (
                        <div className="bg-green-600 text-white px-2 py-1 rounded-full font-bold">
                            Approved
                        </div>
                    )}
                </div>
            ),
            width: "250px",
        },
    ];

    useEffect(() => {
        // const hasViewPermission = hasPermission("PendingScansList");
        // if (!hasViewPermission) {
        //     navigate(`/genefied/${getVendorName()}/`);
        // }

        fetchPendingListFunction();
    }, [limit, offset]);

    useEffect(() => {
        toast.dismiss();

        if (pendingListData) {
            console.log("Issue Report", pendingListData);
            setMyList(
                pendingListData.body && pendingListData.body.list
                    ? pendingListData.body.list
                    : [],
            );
            setTotalRows(
                pendingListData.body && pendingListData.body.total
                    ? pendingListData.body.total
                    : 0,
            );
        }

        if (pendingListError) {
            console.log("Issue Report error", pendingListError);
        }
    }, [pendingListData, pendingListError]);

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center ">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Pending QRs List
                        <LinksComponent />
                    </div>
                    <div className="p-3">
                        {/* {issueReportData && issueReportData.body.issueReport && (
              <ExportCSV
                data={issueReportData && issueReportData.body.issueReport}
                columnsToExport={["name", "mobile", "qr_id", "user_type"]}
              />
            )}   */}

                        <div className="flex gap-2 mb-2">
                            <div>
                                <CustomExport
                                    fetchData={fetchPendingListCsvFunction}
                                    data={csvData}
                                    defaultColumnExport={[
                                        "name",
                                        "mobile",
                                        "qr_id",
                                        "user_type",
                                    ]}
                                    filename="pending_qr_report"
                                />
                            </div>
                        </div>

                        <div className="w-full bg-white shadow rounded-lg">
                            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <div className="flex space-x-2 justify-between">
                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Mobile
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Mobile No..."
                                                required
                                                value={request.mobile}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            mobile: newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Product Code
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2   text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Product Code..."
                                                required
                                                value={request.product_code}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            product_code:
                                                                newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Product Name
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Product Name..."
                                                required
                                                value={request.product_name}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            product_name:
                                                                +newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Status
                                            </label>
                                            <select
                                                value={request.status}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            status: newValue,
                                                        };
                                                    });
                                                }}
                                            >
                                                {statusLabelOptions.map(
                                                    (option) => (
                                                        <option
                                                            key={option.value}
                                                            value={option.value}
                                                        >
                                                            {option.label}
                                                        </option>
                                                    ),
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Unique QR Code
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Unique QR Code..."
                                                required
                                                value={request.unique_code}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            unique_code:
                                                                newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Start Date
                                            </label>
                                            <input
                                                type="date"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="Start Date"
                                                value={request.startDate}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            startDate: newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                End Date
                                            </label>
                                            <input
                                                type="date"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 "
                                                placeholder="End Date"
                                                value={request.endDate}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            endDate: newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex flex-row w-52 gap-2 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right pdbtn_all"
                                                onClick={() => {
                                                    fetchPendingListFunction();
                                                    // fetchIssueReportCsvFunction();
                                                }}
                                            >
                                                Search
                                            </button>
                                        </div>
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                                onClick={() => {
                                                    clearFilters();
                                                }}
                                            >
                                                Clear Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <DataTableComponent
                                    keyField={(row) => row.SNo}
                                    columns={columns}
                                    // title={""}
                                    data={myList}
                                    // loading={loading}
                                    totalRows={totalRows}
                                    handlePerRowsChange={handlePerRowsChange}
                                    handlePageChange={handlePageChange}
                                    paginationDefaultPage={currentPage}
                                    paginationResetDefaultPage={paginationResetToggle}
                                ></DataTableComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PendingQrs;
